const mediaItems = [
  {
    title: '91免费在线视频 · 本周热门推荐',
    desc: '精选本周播放量最高的91免费在线视频内容，涵盖最受欢迎的热门频道与题材。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20dark%20scene%20with%20elegant%20red%20and%20gold%20lighting%2C%20abstract%20theater%20atmosphere%2C%20soft%20glowing%20accents%2C%20luxurious%20velvet%20texture%2C%20artistic%20composition%2C%20no%20people&width=900&height=506&seq=media-01&orientation=landscape',
    duration: '合集',
    views: '158.6万',
  },
  {
    title: '91免费视频网站 · 月度精选回顾',
    desc: '回顾本月91免费视频网站最受欢迎的内容，一网打尽优质推荐不遗漏。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20abstract%20cinematic%20background%20with%20warm%20crimson%20and%20amber%20gradients%2C%20soft%20light%20beams%2C%20elegant%20atmosphere%2C%20entertainment%20mood%2C%20no%20explicit%20content&width=900&height=506&seq=media-02&orientation=landscape',
    duration: '精选',
    views: '132.3万',
  },
  {
    title: '91福利视频在线 · 品质推荐',
    desc: '91福利视频在线频道专属推荐，精选高品质内容，不一样的观看体验。',
    img: 'https://readdy.ai/api/search-image?query=Luxurious%20dark%20atmosphere%20with%20rich%20red%20and%20gold%20lighting%2C%20abstract%20curtain%20shapes%2C%20cinematic%20glow%2C%20sophisticated%20entertainment%20visual%2C%20artistic%2C%20no%20people&width=900&height=506&seq=media-03&orientation=landscape',
    duration: '推荐',
    views: '115.8万',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="bg-background-900 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-2">视频专区</h2>
        <p className="text-sm text-foreground-400 text-center mb-10">91麻豆免费视频网站精选视频推荐，点击探索更多精彩内容</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group block bg-background-800/60 border border-background-700/50 rounded-xl overflow-hidden hover:border-primary-500/50 transition-all duration-200 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-video bg-background-800">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-200 shadow-lg">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-100 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-400 leading-relaxed mb-3">{item.desc}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}